import { HelperResult, SpecificStatuses, UserSpecificStatus } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: useUserSpecificStatuses, useUpdate: useUpdateUserSpecificStatuses } = getCRUDHooks({
  entityName: 'userSpecificStatuses',
  get: ({ userId }): HelperResult<UserSpecificStatus[]> =>
    clientApi.getOCClient().helpers.user.users.id(userId).specificStatuses.find(),
  update: (values, { userId, context }) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .specificStatuses.update('', values, false)
      .setHeader('X-Request-Context', context)
      .execute(),
});

const { useGet: useSpecificStatuses } = getCRUDHooks({
  entityName: 'specificStatuses',
  get: ({ countries }): HelperResult<SpecificStatuses[]> =>
    clientApi.getOCClient().helpers.specificStatuses.specificStatuses.find({ countries }),
});

export { useUserSpecificStatuses, useUpdateUserSpecificStatuses, useSpecificStatuses };
